import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projections',
  templateUrl: './projections.component.html',
  styleUrls: ['./projections.component.scss']
})
export class ProjectionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
